const $slickCarouselProducts = $(".slickCarouselProducts");
const slickSettingsCarouselProducts = {
	slidesToShow: 5,
	slidesToScroll: 1,
	speed: 1500,
	dots: true,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 2000,
	responsive: [
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 4,
			},
		},
		{
			breakpoint: 1023,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 780,
			settings: {
				slidesToShow: 1,
			},
		},
	],
};
$slickCarouselProducts.slick(slickSettingsCarouselProducts);

window.addEventListener('load', function() {
	const $slickMarquee = $(".slickMarquee");
	const slickSettingsMarquee = {
		speed: 8000,
		autoplay: true,
		autoplaySpeed: 0,
		arrows: false,
		dots: false,
		centerMode: true,
		cssEase: "linear",
		slidesToShow: 6,
		slidesToScroll: 1,
		variableWidth: true,
		rtl: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 5,
				},
			},
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 780,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	};
	$slickMarquee.slick(slickSettingsMarquee);
	$slickMarquee.removeClass('sp-hidden');

	const $slickBigMarquee = $(".slickBigMarquee");
	const slickSettingsBigMarquee = {
		speed: 20000,
		autoplay: true,
		autoplaySpeed: 0,
		arrows: false,
		dots: false,
		centerMode: true,
		cssEase: "linear",
		slidesToShow: 6,
		slidesToScroll: 1,
		variableWidth: true,
		rtl: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 5,
				},
			},
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 780,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	};
	$slickBigMarquee.slick(slickSettingsBigMarquee);
	$slickBigMarquee.removeClass('sp-hidden');
});

const swiper = new Swiper(".swiperProducts", {
	slidesPerView: 2.05,
	spaceBetween: 10,
	freeMode: true,
	pagination: {
		el: ".swiperProducts .swiper-pagination",
	},
	navigation: {
		nextEl: ".customSwiperButton.swiper-button-next",
		prevEl: ".customSwiperButton.swiper-button-prev",
	},
	breakpoints: {
		1024: {
			slidesPerView: 1.2,
			spaceBetween: 20,
		},
		1200: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
	},
});

$(".menu-drawer__close").on('click', function() {
})

/* Header */
$(document).ready(function () {
	var $header = $("header");
	$(window).scroll(function () {
		if ($(this).scrollTop() > 50) {
			$header.addClass("scrolled");
		} else {
			$header.removeClass("scrolled");
		}
	});
	if ($(window).scrollTop() > 50) {
		$header.addClass("scrolled");
	}
});

document.addEventListener('DOMContentLoaded', function() {
	document.addEventListener('rebuy:cart.change', (event) => { 
		//console.log('rebuy:cart.change event', event.detail); 
		const { cart } = event.detail;
		const items = cart.cart.items;

		const property = {
			_one_time_starter_kit: true
		}

		const starterKitShakerGift = items.find((cartItem) => cartItem.variant_id === ULTIMATE_STARTER_KIT.giftVariantId && cartItem.properties['_one_time_starter_kit']);
      	const ultimateStarterKit = items.find((cartItem) => cartItem.variant_id === ULTIMATE_STARTER_KIT.variantId && cartItem.selling_plan_allocation === undefined);

		if((starterKitShakerGift && ultimateStarterKit) && (ultimateStarterKit.quantity !== starterKitShakerGift.quantity)) {
			Rebuy.Cart.changeItem({ id: starterKitShakerGift.key, quantity: ultimateStarterKit.quantity})
			return;
		}
		else if(!starterKitShakerGift && ultimateStarterKit) {
			window.Rebuy.Cart.addItem({id: ULTIMATE_STARTER_KIT.giftVariantId, quantity: ultimateStarterKit.quantity, properties: property})
		}

	});

	var image = document.getElementsByClassName('parallax-image');
	new simpleParallax(image, {
			scale: 1.5,           // Escala de la imagen (1 = tamaño original)
			orientation: 'up',    // Dirección del movimiento (up, down, left, right)
			overflow: true,       // Permitir que la imagen se desborde de su contenedor
			delay: 0.5,           // Retraso del efecto
			transition: 'ease' // Tipo de transición
	});
});

/* ============================================================================
 * SEEQ — Target PDP: overlay Shop Now link on Tvarka sticky add-to-cart button
 * --------------------------------------------------------------------------
 * The Tvarka sticky-add-to-cart app injects its own button into
 * `.tvarka-satc__cta-container` after page load and may re-render it on
 * variant changes. For products with `template_suffix == 'target-pdp'` we
 * render a hidden `.seeq-sticky-shop-now-data` element (see
 * snippets/buy-buttons.liquid) carrying the Shop Now URL/label from the
 * `metafields.custom.shop_now_link` metafield. This script reads those
 * values and overlays a transparent `<a>` on top of the app's button so the
 * sticky CTA navigates to the metafield URL instead of triggering ATC. The
 * MutationObserver re-attaches the overlay if the app removes/replaces it.
 * ========================================================================== */
(function () {
  var dataEl = document.querySelector('.seeq-sticky-shop-now-data');
  if (!dataEl) return;
  var SHOP_NOW = {
    url: dataEl.getAttribute('data-url') || '',
    text: dataEl.getAttribute('data-text') || 'SHOP NOW'
  };
  if (!SHOP_NOW.url) return;

  var CTA_SELECTOR = '.tvarka-satc__cta-container';
  var OVERLAY_CLASS = 'seeq-sticky-shop-now-overlay';

  function ensureOverlay(container) {
    if (!container) return;
    if (container.querySelector('.' + OVERLAY_CLASS)) return;

    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }

    var link = document.createElement('a');
    link.href = SHOP_NOW.url;
    link.className = OVERLAY_CLASS + ' tvarka-satc__button-primary tvarka-satc__u-cursor-pointer tvarka-satc__u-inherit-font-family';
    link.setAttribute('aria-label', SHOP_NOW.text);
    link.style.cssText = [
      'position:absolute',
      'inset:0',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'z-index:10',
      'text-decoration:none'
    ].join(';');

    var span = document.createElement('span');
    span.className = 'tvarka-satc__u-line-wrap-2';
    span.textContent = SHOP_NOW.text;
    link.appendChild(span);

    container.appendChild(link);
  }

  function scan() {
    var containers = document.querySelectorAll(CTA_SELECTOR);
    for (var i = 0; i < containers.length; i++) ensureOverlay(containers[i]);
  }

  var observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
